var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChatEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.167 35.083V6.792q0-1.084.771-1.854.77-.771 1.854-.771h26.416q1.084 0 1.854.771.771.77.771 1.854v19.75q0 1.083-.771 1.854-.77.771-1.854.771H10.083ZM6.25 30l2.917-2.917h24.041q.25 0 .396-.145.146-.146.146-.396V6.792q0-.25-.146-.396-.146-.146-.396-.146H6.792q-.25 0-.396.146-.146.146-.146.396Zm0-23.208V6.25 30Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatEmpty);
export default __webpack_public_path__ + "static/media/icon-chat-empty.55588eeea5ca8af2eafcc584cfece16c.svg";
export { ForwardRef as ReactComponent };